import { HeadCell, ACTION} from '../../../../../component/table/interfaces/TableInterface';

export const HEAD_CELL: Array<HeadCell> = [
  { id: 'Docas', label: 'Docas' },
  { id: 'Lojas', label: 'Lojas ' },
  { id: 'DiaSemana', label: 'Dia da Semana ' },
  { id: 'HorarioInicio', label: 'Horário Inicio' },
  { id: 'HorarioFim', label: 'Horário Fim' },
  { id: 'Status', label: 'Status' },
  { id: ACTION, label: ''},
];